export const APP_YEAR = 2026;
export const LAST_UPDATED_DATE = "January 2026";

